import { UploadEvent, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UUID } from 'angular2-uuid';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { SupplierService } from 'src/app/services/supplier/supplier.service';

declare var jsforce: any;
@Component({
  selector: 'upload-supplier-form',
  templateUrl: './upload-supplier-form.component.html',
  styleUrls: ['./upload-supplier-form.component.scss']
})

export class UploadSupplierFormComponent implements OnInit {
  public claimAttachments: any[] = [];
  public supportedFileTypes: string[] = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '.csv', 'text/csv'];

  public maximumFileSizeInBytes: number = 25000000;
  public hasBaseDropZoneOver: boolean = false;
  public uploadedFiles: any[] = [];
  public uploadedAttachments = [];
  public filesAreUploading: boolean = false;
  private target: any;
  public toggleAccordian;
  public loading: boolean = false;
  constructor(private supplierService: SupplierService, private router: Router,
    public currentUserService: CurrentUserService,
    private flashMessageService: FlashMessageService) { }

  ngOnInit() {
    this.supplierService.pageUrl.next(this.router.url);
  }

  public dropped(event: UploadEvent) {
    let status = true;
    for (const droppedFile of event.files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (!status)
            return; // we dont want to spam the user with a bunch of alerts.
          status = this.testCriteria(file);
        });
      } else {
        // idk what to do here prlly just return or do nothing
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }

  public onFileSelected(fileSelected) {
    var files = fileSelected.target.files;
    for (const file of files) {
      this.testCriteria(file);
    }
  }

  public openFileBrowser() {
    document.getElementById('file-input').click();
  }

  private testCriteria(file) {
    let fileTypeisSupported = false;
    let fileSizeisSupported = false;
    let sameFileUploaded = false;

    //check if file is already uploaded
    this.uploadedAttachments.forEach(uploadedFile => {
      if (file.name == uploadedFile.file_name) {
        alert(`A file called ${file.name} has already been uploaded`);
        sameFileUploaded = true;
        return;
      }
    })

    if (sameFileUploaded)
      return;

    // check if the file is an accepted type
    this.supportedFileTypes.forEach(fileType => {
      if (file.type == fileType) {
        fileTypeisSupported = true;
      }
    })

    // check if the file is an accepted size
    if (fileTypeisSupported) {
      if (file.size <= this.maximumFileSizeInBytes)
        fileSizeisSupported = true;
    }
    else {
      alert(file.name + ' is an unsupported file type. Please submit an excel document.');
      return false;
    }

    // we will post the uploaded file
    if (fileTypeisSupported && fileSizeisSupported) {
      this.postFile(file)
    }
    else {
      alert(file.name + ' is too large to upload. please try to keep the file under 25MB');
      return false;
    }
  }


  public removeFile(item) {
    this.uploadedAttachments.forEach((uploadedFile, index) => {
      if (item.file_name == uploadedFile.file_name) {
        this.uploadedAttachments.splice(index, 1);
      }
    })
  }

  private postFile(fileToPost) {
    this.filesAreUploading = true;
    var fd = new FormData();

    fd.append('file', fileToPost);
    let uuid = UUID.UUID();

    this.supplierService.uploadFile(fd).then((resp) => {
      let suppliersFailed = [];
      this.filesAreUploading = false;
      resp['suppliers'].forEach(function (obj, index) {
        if ("error" in obj) {
          suppliersFailed.push({ name: obj.supplier.name, email: obj.supplier.corporate_email, phone: obj.supplier.corporate_phone, address1: obj.supplier.address1, zip: obj.supplier.zip, error: obj.error })
        }
      })
      if (!suppliersFailed.length) {
        this.flashMessageService.updateMessage("All Suppliers uploaded successfully", 3000, "success");
      }
      else {
        this.uploadedFiles.push({ "file_name": fileToPost.name, id: uuid, suppliersFailed: suppliersFailed });
      }

    })
      .catch((err) => {
        this.removeFile(fileToPost);
        this.handleError(err);
        this.filesAreUploading = false;
        alert('There was an issue uploading your file, ' + fileToPost.name);
      })
    this.removeFile(fileToPost);
  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  // toggleAccordian(id) {
  //   if ($('#' + id).hasClass('show')) {
  //     $('#' + id).addClass('hide');
  //     $('#' + id).removeClass('show');
  //     $('#img-' + id).attr('src', 'assets/images/icons/arrow-down.svg');
  //   }
  //   else {
  //     $('#' + id).addClass('show');
  //     $('#' + id).removeClass('hide');
  //     $('#img-' + id).attr('src', 'assets/images/icons/arrow-up.svg');
  //   }

  // }

}
